import { IconsTypes } from "../../types";

import * as styles from "./styles";
import { ComponentAlertProps } from "./types";

export const ComponentAlert = ({
  id,
  onClose,
  type,
  title,
  className = "",
}: ComponentAlertProps) => {
  return (
    <article
      className={`alert animate__animated ${styles.article(type)} ${className}`}
    >
      {type === "alert" ? (
        <i className={`${"fas fa-info" as IconsTypes}`} />
      ) : (
        <i className={`${"fas fa-check" as IconsTypes}`} />
      )}
      <p className={`${styles.title}`}>{title}</p>
      <i
        className={`close ${"fas fa-times" as IconsTypes}`}
        onClick={() => (onClose ? onClose(id) : null)}
      />
    </article>
  );
};
